import React, { useEffect, useState } from "react";
import { Modal, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import {
  useBlockRoomsMutation,
  useBlockVillaPhaseMutation,
  useLazyListPhasesQuery,
  useLazyListRoomsQuery,
  useLazyPropertyServiceQuery,
  useLazyShowGetToGetherQuery,
  useLazyShowRoomQuery,
} from "../../redux/api/api";
import { saveLoader } from "../../redux/slice/loaderNoti";
import CloseIcon from "@mui/icons-material/Close";
import DatePicker from "react-datepicker";
import moment from "moment/moment";
import AddIcon from "@mui/icons-material/Add";
import { editIcon, sorgamseasideicon } from "../../assets/img";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { FaRegEdit } from "react-icons/fa";

const GetTogether = ({ list }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [modal, setModal] = useState(false);
  const [btn, setBtn] = useState(false);
  const [phaseList, setPhaseList] = useState([]);
  const [slotList, setSlotList] = useState({});
  const [roomList, setRoomList] = useState([]);
  const [get_together, setget_together] = useState({});

  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());

  const [from_date, setfrom_date] = useState("");
  const [no_of_persons, setno_of_persons] = useState("");
  const [no_of_rooms, setno_of_rooms] = useState("");
  const [to_date, setto_date] = useState("");
  const [property_phase_service_slot_id, setproperty_phase_service_slot_id] =
    useState("");
  const [from_dateErr, setfrom_dateErr] = useState(false);
  const [no_of_personsErr, setno_of_personsErr] = useState(false);
  const [no_of_roomsErr, setno_of_roomsErr] = useState(false);
  const [to_dateErr, setto_dateErr] = useState(false);
  const [
    property_phase_service_slot_idErr,
    setproperty_phase_service_slot_idErr,
  ] = useState(false);

  // RTK QUERY
  const [propertyServiceApi] = useLazyPropertyServiceQuery();
  const [listPhasesApi] = useLazyListPhasesQuery();
  const [showRoomApi] = useLazyShowRoomQuery();
  const [blockVillaPhaseApi] = useBlockVillaPhaseMutation();
  const [blockRoomsApi] = useBlockRoomsMutation();
  const [showGetToGetherApi] = useLazyShowGetToGetherQuery();
  const [listRoomsApi] = useLazyListRoomsQuery();

  const showGetToGether = () => {
    showGetToGetherApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        setget_together(res?.get_together);
        // setDetails(res?.day_outing);
        // setfood_packages(res?.food_packages);
        // setamenities(res?.amenities);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const listRooms = () => {
    listRoomsApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        setRoomList(res?.rooms);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getView = (type) => {
    propertyServiceApi({ id: location?.state?.data?.id, type: type })
      .unwrap()
      .then((res) => {
        // setDetails(res?.day_outing);
        // setfood_packages(res?.food_packages);
        // setamenities(res?.amenities);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getPhaseList = () => {
    listPhasesApi(location?.state?.data?.id)
      .unwrap()
      .then((res) => {
        setPhaseList(res?.phases);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const getShowRoom = (id) => {
    showRoomApi(id)
      .unwrap()
      .then((res) => {
        setSlotList(res?.room);
        setModal(true);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const minMaxDate = () => {
    var someDate = new Date();

    // min date
    someDate.setDate(someDate.getDate()); //number  of days to add, e.x. 15 days
    var dateFormated = someDate.toISOString().substr(0, 10);
    setMinDate(dateFormated);

    // max date
    someDate.setDate(someDate.getDate() + 7); //number  of days to add, e.x. 15 days
    var dateFormateds = someDate.toISOString().substr(0, 10);
    setMaxDate(dateFormateds);
  };

  useEffect(() => {
    if (location?.state?.data?.id) {
      getPhaseList();

      if (list?.property?.category?.name !== "Villa") {
        listRooms();
        showGetToGether();
        getView("room_booking");
      } else {
        getView("get_together");
      }
    }
    minMaxDate();
  }, []);

  const onClose = () => {
    setfrom_date("");
    setto_date("");
    setno_of_persons("");
    setproperty_phase_service_slot_id("");
    setfrom_dateErr(false);
    setto_dateErr(false);
    setno_of_personsErr(false);
    setproperty_phase_service_slot_idErr(false);
    setno_of_rooms("");
    setno_of_roomsErr(false);
    setModal(false);
  };

  const phaseBlock = () => {
    if (
      from_date?.length == 0 ||
      to_date?.length == 0 ||
      no_of_persons?.length == 0 ||
      (list?.property?.category?.name !== "Villa" &&
        no_of_rooms?.length == 0) ||
      property_phase_service_slot_id?.length == 0
    ) {
      setfrom_dateErr(true);
      setto_dateErr(true);
      setno_of_personsErr(true);
      setproperty_phase_service_slot_idErr(true);
      if (list?.property?.category?.name !== "Villa") {
        setno_of_roomsErr(true);
      }
    } else {
      const formdata = new FormData();

      formdata.append("from_date", moment(from_date).format("YYYY-MM-DD"));
      formdata.append("no_of_persons", no_of_persons);
      formdata.append("to_date", moment(to_date).format("YYYY-MM-DD"));

      if (list?.property?.category?.name !== "Villa") {
        formdata.append("property_room_id", slotList?.id);

        formdata.append(
          "property_room_service_slot_id",
          property_phase_service_slot_id
        );

        formdata.append("no_of_rooms", no_of_rooms);

        formdata.append("type", "get_together");

        dispatch(saveLoader(true));
        setBtn(true);
        blockRoomsApi(formdata)
          .unwrap()
          .then((res) => {
            Swal.fire({
              text: res?.message,
              icon: "success",
            });
            dispatch(saveLoader(false));
            setBtn(false);
            onClose();
          })
          .catch((err) => {
            console.log("err", err);
            dispatch(saveLoader(false));
            setBtn(false);
          });
      } else {
        formdata.append("property_phase_id", slotList?.id);
        formdata.append(
          "property_phase_service_slot_id",
          property_phase_service_slot_id
        );

        dispatch(saveLoader(true));
        setBtn(true);
        blockVillaPhaseApi(formdata)
          .unwrap()
          .then((res) => {
            Swal.fire({
              text: res?.message,
              icon: "success",
            });
            dispatch(saveLoader(false));
            setBtn(false);
            onClose();
          })
          .catch((err) => {
            console.log("err", err);
            dispatch(saveLoader(false));
            setBtn(false);
          });
      }
    }
  };

  console.log("list", list);

  return (
    <div>
      <div>
        <Row>
          <div className="col-md-12 d-flex ac-je">
            <div className="block-header add-btn-new">
              <button
                onClick={() => {
                  let state = {
                    data: location?.state?.data,
                    service_type: "get_together",
                  };

                  if (get_together?.id) {
                    state.itemType = "edit";
                  }

                  navigate("/weekend-room-service", {
                    state: state,
                  });
                }}
                className="f2 d-flex text-nowrap"
              >
                <AddIcon />
                Weekend Price
              </button>
            </div>
            {list?.property?.category?.name !== "Villa" && (
              <div className="block-header add-btn-new">
                <button
                  onClick={() =>
                    navigate("/room", {
                      state: {
                        data: location?.state?.data,
                        service_type: "room_booking",
                      },
                    })
                  }
                  className="f2 d-flex text-nowrap"
                >
                  <AddIcon />
                  Add Room
                </button>
              </div>
            )}
          </div>
        </Row>
        {list?.property?.category?.name !== "Villa" ? (
          <div>
            {" "}
            {roomList?.map((item, ind) => {
              return (
                <Row className="col-md-12 property-available" key={ind}>
                  <div className="col-md-3">
                    <div className="property-img">
                      <img
                        src={
                          item?.image != null
                            ? item?.image?.image
                            : sorgamseasideicon
                        }
                        alt="property-image"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="property-details room-det">
                      <h3>
                        <button
                          className="link-btn f2"
                          onClick={() =>
                            navigate("/room-view", {
                              state: { data: item, type: "view" },
                            })
                          }
                        >
                          {item?.room_name}
                        </button>
                      </h3>
                      <ul className="d-flex ac-js gap-2">
                        <li class="edt-rooms">
                          <button
                            className="a-btn cust-btn d-flex ac-jc gap-1 f2"
                            onClick={() =>
                              navigate("/room-edit", {
                                state: {
                                  data: location?.state?.data,
                                  service_type: "room_booking",
                                  item: item,
                                  itemType: "edit",
                                },
                              })
                            }
                          >
                            <FaRegEdit /> Edit
                          </button>
                        </li>
                        <li class="edt-rooms">
                          <button
                            className="btn-secondary f2"
                            onClick={() => getShowRoom(item?.id, "phase")}
                          >
                            Block Room
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Row>
              );
            })}
          </div>
        ) : (
          <div>
            {phaseList?.map((item, ind) => {
              return (
                <Row className="col-md-12 property-available" key={ind}>
                  <div className="col-md-3">
                    <div className="property-img">
                      <img
                        src={
                          item?.image != null
                            ? item?.image?.image
                            : sorgamseasideicon
                        }
                        alt="property-image"
                        className="img-fluid"
                      />
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div className="property-details room-det">
                      <h3>
                        <button
                          className="link-btn f2"
                          onClick={() =>
                            navigate("/room-view", {
                              state: { data: item, type: "view" },
                            })
                          }
                        >
                          {item?.room_name}
                        </button>
                      </h3>
                      <ul className="d-flex ac-js gap-2">
                        <li class="edt-rooms">
                          <button
                            className="a-btn cust-btn d-flex ac-jc gap-1 f2"
                            onClick={() =>
                              navigate("/phase", {
                                state: {
                                  data: location?.state?.data,
                                  service_type: "room_booking",
                                  item: item,
                                  itemType: "edit",
                                },
                              })
                            }
                          >
                            <FaRegEdit /> Edit
                          </button>
                        </li>
                        <li class="edt-rooms">
                          <button
                            className="btn-secondary f2"
                            onClick={() => getShowRoom(item?.id, "phase")}
                          >
                            Phase Block
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </Row>
              );
            })}
          </div>
        )}
      </div>

      <Modal
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="p-3">
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20">
                {list?.property?.category?.name !== "Villa"
                  ? "Block Room"
                  : "Block Phase"}
              </label>
              <button className="cust-btn" onClick={() => onClose(false)}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row className="mt-4">
            <div className="col-md-12 mb-4">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                From Date
              </label>
              <div className="full-date-pick">
                <DatePicker
                  selected={from_date}
                  onChange={(date) => {
                    setfrom_date(date);
                  }}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  dateFormat="yyyy-MM-dd"
                  todayButton="Today"
                  className="form-control custom-select"
                  placeholderText="YYYY-MM-DD"
                  minDate={minDate}
                  maxDate={maxDate}
                />
              </div>
              {from_date?.length == 0 && from_dateErr && (
                <p className="err">Select From Date</p>
              )}
            </div>
            <div className="col-md-12 mb-4">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                To Date
              </label>
              <div className="full-date-pick">
                <DatePicker
                  selected={to_date}
                  onChange={(date) => {
                    setto_date(date);
                  }}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  dateFormat="yyyy-MM-dd"
                  todayButton="Today"
                  className="form-control custom-select"
                  placeholderText="YYYY-MM-DD"
                  minDate={minDate}
                  //   maxDate={maxDate}
                />
              </div>
              {to_date?.length == 0 && to_dateErr && (
                <p className="err">Select To Date</p>
              )}
            </div>
            <div className="col-md-12 mb-4 d-flex ac-js">
              <div className="col-md-3">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                  No of Persons
                </label>
              </div>
              <div className="col-md-4">
                <input
                  onChange={(e) => setno_of_persons(e.target.value)}
                  value={no_of_persons}
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                />
                {no_of_persons?.length == 0 && no_of_personsErr && (
                  <p className="err">Enter No of Persons</p>
                )}
              </div>
            </div>
            {list?.property?.category?.name !== "Villa" && (
              <div className="col-md-12 mb-4 d-flex ac-js">
                <div className="col-md-3">
                  <label className="f2 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                    No of Rooms
                  </label>
                </div>
                <div className="col-md-4">
                  <input
                    onChange={(e) => setno_of_rooms(e.target.value)}
                    value={no_of_rooms}
                    className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  />
                  {no_of_rooms?.length == 0 && no_of_roomsErr && (
                    <p className="err">Enter No of Rooms</p>
                  )}
                </div>
              </div>
            )}
            <div className="col-md-12 mb-4">
              <div className="form-group">
                <label className="f2 fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20 mb-2">
                  Time Slots
                </label>
                <select
                  className="add-admin-frm fs-sm-12 fs-md-12 fs-lg-16 fs-xl-17 fs-xxl-20"
                  onChange={(e) =>
                    setproperty_phase_service_slot_id(e.target.value)
                  }
                  value={property_phase_service_slot_id}
                >
                  <option value={""} disabled>
                    Select Time Slots
                  </option>
                  {slotList?.timeslots?.map((item, ind) => {
                    return (
                      <option value={item?.id} key={ind}>
                        {item?.timeslot?.name + "-" + item?.timeslot?.type}
                      </option>
                    );
                  })}
                </select>
              </div>
              {property_phase_service_slot_id?.length == 0 &&
                property_phase_service_slot_idErr && (
                  <p className="err">Select Time Slots</p>
                )}
            </div>
          </Row>
          <Row className="mt-4 d-flex ac-jc">
            <div className="col-md-2 text-center">
              <button
                className={`submit-btn ${btn ? "opacity-50" : ""}`}
                onClick={() => phaseBlock()}
                disabled={btn}
              >
                OK
              </button>
            </div>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default GetTogether;
